<template>

    <label class="form-label">Nombre de Variable</label>
    <input required
      class="form-control"
      v-model="widgetConfig.variableFullName"
      type="text"
    />

    <div>
      <label for="" class="form-label">ID Variable (MQTT) </label>
      <input
        class="form-control"
        v-model="widgetConfig.variable"
        type="text"
        :disabled="route.path == '/edit-templates'"
      />
    </div>

    <label class="form-label">Seleccionar Tamaño</label>
    <select
      v-model="widgetConfig.column"
      class="form-select"
      style="width: 100%"
      required
    >
      <option value="col-md-3 col-sm-12" label="Pequeño"></option>

      <option value="col-md-6 col-sm-12" label="Mediano"></option>

      <option value="col-12" label="Grande"></option>
    </select>

</template>

<script>
import IconsForm from "@/components/Templates/common/CommunInputs.vue"
import {useRoute} from "vue-router";
export default {
    components: {
        IconsForm
    },
    name:"CommunInputs",
    props: ["widgetConfig"],
    setup() {
      const route = useRoute()
      return {
        route
      }
    }

    }
    

</script>
